import { API_URL } from '../../environments/environment';

export const apiUrl = {
    /** auth **/
    login: `${API_URL}/auth/login`,
    register: `${API_URL}/auth/register`,
    registerLegal: `${API_URL}/auth/register/legalEntity`,
    resendEmail: `${API_URL}/auth/register/resend`,
    forgetPassword: `${API_URL}/auth/password/forget`,
    changePassword: `${API_URL}/auth/password/set`,
    userExist: `${API_URL}/auth/register/exist`,
    deleteUser: `${API_URL}/auth/user`,
    verify: `${API_URL}/auth/register/verify/{token}`,
    setPassword: `${API_URL}/auth/register/password`,
    verifyForget: `${API_URL}/auth/password/forget/verify/{token}`,
    regiterPdpa: `${API_URL}/auth/register/pdpa`,
    getToken: `${API_URL}/auth/renewToken`,
    ownerExist: `${API_URL}/auth/user/owner/exist`,
    ownerNames: `${API_URL}/auth/user/owner/names`,
    menuPermission: `${API_URL}/auth/menu`,
    /** profile **/
    profileChangePassword: `${API_URL}/auth/password/change`,
    profileUpdate: `${API_URL}/auth/profile`,
    profile: `${API_URL}/auth/profile`,
    /** menu **/
    menuShortcut: `${API_URL}/menu/shortcut`,
    menu: `${API_URL}/menu`,
    /** request **/
    requestSearch: `${API_URL}/request/search`,
    userDetail: `${API_URL}/request/user`,
    userOwnerList: `${API_URL}/auth/user/owner/names`,
    userOwnerExistByIdCard: `${API_URL}/auth/user/owner/exist/{idCard}`,
    landUseFul: `${API_URL}/request/lookup/landuseful`,
    requestTaxYears: `${API_URL}/request/lookup/taxYears`,
    /** estate **/
    estateLand: `${API_URL}/estate/land`,
    estateBuilding: `${API_URL}/estate/building`,
    estateCondo: `${API_URL}/estate/condo`,
    estateSign: `${API_URL}/estate/sign`,
    estateSearchLandAndBuilding: `${API_URL}/estate/landAndBuilding/search`,
    estateSearchLand: `${API_URL}/estate/land/search`,
    estateSearchBuilding: `${API_URL}/estate/building/search`,
    estateSearchCondo: `${API_URL}/estate/condo/room/search`,
    estateSearchSign: `${API_URL}/estate/sign/search`,
    estateBuildingDetail: `${API_URL}/estate/building/details`,
    estateLandDetail: `${API_URL}/estate/land/details`,
    estateCondoDetail: `${API_URL}/estate/condo/room/details`,
    estateLandUsedDetail: `${API_URL}/estate/landUsedDetail`,
    estateBuildingUsedDetail: `${API_URL}/estate/buildingUsedDetail`,
    estateCondoRoomUsedDetail: `${API_URL}/estate/condoRoomUsedDetail`,
    /** estate payment**/
    estateLandAndBuildingHistory: `${API_URL}/Estate/landAndBuilding/history`,
    estateLandHistory: `${API_URL}/Estate/land/history`,
    estateBuildingHistory: `${API_URL}/Estate/building/history`,
    estateCondoHistory: `${API_URL}/Estate/condo/room/history`,
    estateSignHistory: `${API_URL}/Estate/sign/history`,
    estateLandAndHouseHistory: `${API_URL}/Estate/refHouse/history`,
    estateLocalMaintenance: `${API_URL}/Estate/refLand/history`,
    estateAllHistory: `${API_URL}/Estate/all/history`,

    /** estate lookup**/
    estateAdministrativeDistrict: `${API_URL}/Estate/administrative/district`,
    estateAdministrativeSubDistrict: `${API_URL}/Estate/administrative/subdistrict`,
    estateAdministrativeDistrictOffice: `${API_URL}/Estate/administrative/district-office`,
    estateAdministrativeLandHouseDistrictOffice: `${API_URL}/Estate/administrative/district-office/landhouse`,
    estateAdministrativeLocalDevDistrictOffice: `${API_URL}/Estate/administrative/district-office/localdev`,
    estateLookupTaxYears: `${API_URL}/Estate/lookup/taxyears`,
    estateLookupBuildingType: `${API_URL}/Estate/lut/buildingUsedType`,

    // ** identify  **/
    identifyLand: `${API_URL}/Identify/land`,
    idetifyUpdateLandPhoto: `${API_URL}/Estate/land`,
    identifyBuilding: `${API_URL}/Identify/building`,
    identifyCondo: `${API_URL}/Identify/condo`,
    identifyRoom: `${API_URL}/Identify/condo/room`,
    identifySigns: `${API_URL}/Identify/sign`,

    /** pds5 **/
    pdsFiveAddDraft: `${API_URL}/request/pds5/draft`,
    pdsFiveDeleteDraft: `${API_URL}/request/pds5/draft`,
    pdsFiveUpdateDraft: `${API_URL}/request/pds5/draft`,
    pdsFiveSubmit: `${API_URL}/request/pds5/submit`,
    getRequestPdsFive: `${API_URL}/Request/pds5/{requestId}`,
    getPdsFiveRequestForm: `${API_URL}/Request/pds5/form`,
    pdsFiveCancelRequest: `${API_URL}/Request/pds5/cancel`,
    /** pds10 **/
    pdsTenAddDraft: `${API_URL}/Request/pds10/draft`,
    pdsTenDeleteDraft: `${API_URL}/Request/pds10/draft`,
    pdsTenUpdateDraft: `${API_URL}/Request/pds10/draft`,
    pdsTenSubmit: `${API_URL}/Request/pds10/submit`,
    getRequestPdsTenMaster: `${API_URL}/Request/pds10/master`,
    getRequestPdsTen: `${API_URL}/Request/pds10`,
    getPdsTenDocuments: `${API_URL}/Request/pds10/documentsndetails`,
    pdsTenCancelRequest: `${API_URL}/Request/pds10/cancel`,
    getDistrictOffice: `${API_URL}/Administrative/districtoffices`,
    pdsTenCheckDocs: `${API_URL}/Request/pds10/check/pds`,
    pds6Districts: `${API_URL}/Estate/administrative/owner/pds6/district`,
    /** pds32 **/
    section32DeleteDraft: `${API_URL}/request/section32/draft`,
    section32Document: `${API_URL}/Request/section32/form`,
    section32DocumentPDS: `${API_URL}/Request/section32/documents`,

    section32Submit: `${API_URL}/Request/section32/submit`,
    section32SaveDraft: `${API_URL}/Request/section32/draft`,
    section32GetData: `${API_URL}/Request/section32/master`,
    section32GetDraftData: `${API_URL}/Request/section32/draft`,
    section32Edit: `${API_URL}/Request/section32/draft`,
    section32CancelRequest: `${API_URL}/Request/section32/cancel`,

    section32CheckDocs: `${API_URL}/Request/section32/check/pds`,
    section32DocumentsDetails: `${API_URL}/Request/section32/documentsndetails`,
    section32DistrictCont: `${API_URL}/Estate/administrative/owner/pds34/district`,
    /** map **/
    toc: `${API_URL}/config/toc`,
    basemap: `${API_URL}/config/basemap`,
    /** document **/
    document: `${API_URL}/document`,
    documentManual: `${API_URL}/document/manual`,
    documentTaxYears: `${API_URL}/document/lookup/taxYears`,
    documentLog: `${API_URL}/document/log`,
    documentSearchLandAndBuilding: `${API_URL}/Document/searchLandBuilding`,
    documentSearchSign: `${API_URL}/Document/searchSign`,
    documentSearchLandHouse: `${API_URL}/Document/searchLandHouse`,
    documentSearchLocalDev: `${API_URL}/Document/searchLocalDev`,
    documentType: `${API_URL}/document/lookup/DocumentType`,
    documentForm: `${API_URL}/document/form`,
    /** faq **/
    faq: `${API_URL}/faq`,
    faqCount: `${API_URL}/faq/count`,
    faqSearch: `${API_URL}/faq/search`,
    faqLookupCategory: `${API_URL}/faq/lookup/types`,
    faqSavePin: `${API_URL}/faq/pin`, // มาแก้ด้วย

    /** news **/
    news: `${API_URL}/news`,
    newsSearch: `${API_URL}/news/search`,
    /** inbox **/
    message: `${API_URL}/inbox`,
    messageRead: `${API_URL}/inbox/read`,
    /** upload **/
    upload: `${API_URL}/upload`,
    uploadBase64String: `${API_URL}/Attachment/uploadTempFiles/base64String`,
    uploadTemp: `${API_URL}/Attachment/uploadTempFiles`,
    deleteTemp: `${API_URL}/Attachment/deleteTempFile/{tmpFileName}`,
    /** administrative **/
    administrative: `${API_URL}/Administrative`,
    districtOffices: `${API_URL}/Administrative/districtoffices`,
    /** report **/
    reportPDS10: `${API_URL}/reports/export/pds10`,
    /** pdpa **/
    pdpa: `${API_URL}/pdpa`,
};
